import type { PaginationMetadata, PaginationQuery } from './common'

export const SALE_CHANNELS = [
  'office',
  'rider',
  'app',
  'event',
  'other',
] as const

export type SaleChannel = (typeof SALE_CHANNELS)[number]

export const SALE_PAYMENT_STATUSES = [
  'paid',
  'unpaid',
  'partial',
  'cancelled',
] as const

export type SalePaymentStatus = (typeof SALE_PAYMENT_STATUSES)[number]

export const SALE_PAYMENT_METHODS = [
  'cash',
  'edc',
  'qris',
  'app_qris',
  'bank_transfer',
  'credit_unpaid',
] as const

export type SalePaymentMethod = (typeof SALE_PAYMENT_METHODS)[number]

export interface SaleItem {
  id: string
  productId: string
  productName: string
  qty: number
  sellingPrice: number
  total: number
  cogsPerUnit: number | null
  cogsTotal: number | null
  grossProfit: number | null
  margin: number | null
  validation: 'OK' | 'MISSING_COGS'
}

export interface Sale {
  id: string
  workspaceId: string
  date: string
  channel: SaleChannel
  customerName: string
  transactionCode: string | null
  items: SaleItem[]
  total: number
  cogsTotal: number | null
  grossProfit: number | null
  margin: number | null
  validation: 'OK' | 'MISSING_COGS'
  paymentStatus: SalePaymentStatus
  paymentMethod: SalePaymentMethod
  hasReceivablePayments: boolean
  cancelReason: string | null
  notes: string | null
  createdAt: string
  updatedAt: string
}

export interface CreateSaleItemInput {
  productId: string
  qty?: number
  sellingPrice?: number
}

export interface CreateSaleReq {
  date: string
  channel?: SaleChannel
  customerName?: string
  transactionCode?: string
  paymentStatus?: SalePaymentStatus
  paymentMethod?: SalePaymentMethod
  notes?: string
  items: CreateSaleItemInput[]
  // Only honored for actors with canSwitchWorkspace — everyone else always
  // creates in their own workspace regardless of what's sent here.
  workspaceId?: string
}

export interface UpdateSaleReq {
  date?: string
  channel?: SaleChannel
  customerName?: string
  transactionCode?: string
  paymentStatus?: SalePaymentStatus
  paymentMethod?: SalePaymentMethod
  notes?: string
  items?: CreateSaleItemInput[]
}

export interface GetSaleReq {
  q?: string
  channel?: SaleChannel
  paymentStatus?: SalePaymentStatus
  dateFrom?: string
  dateTo?: string
  pagination?: PaginationQuery
}

export interface SaleList {
  items: Sale[]
  pagination: PaginationMetadata
}
